export const TierStarIcon = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0642 3.74769L11.9504 6.39046C12.101 6.83484 12.5283 7.13815 13.0115 7.13815H15.8814C16.9619 7.13815 17.4136 8.47835 16.537 9.09437L14.2158 10.7285C13.8249 11.0036 13.6598 11.4926 13.8103 11.937L14.6966 14.5798C15.0316 15.5767 13.854 16.4043 12.9775 15.7883L10.6563 14.1542C10.2653 13.8791 9.73602 13.8791 9.34267 14.1542L7.02144 15.7883C6.14734 16.4043 4.96973 15.5767 5.30238 14.5798L6.18862 11.937C6.33916 11.4926 6.17405 11.0036 5.78313 10.7285L3.4619 9.09437C2.5878 8.47835 3.03699 7.13815 4.11748 7.13815H6.98745C7.47064 7.13815 7.9004 6.8372 8.04852 6.39046L8.93476 3.74769C9.26983 2.75077 10.7242 2.75077 11.0593 3.74769H11.0642Z"
      fill="#fff"
    />
  </svg>
)
